import React from 'react'
import { motion } from 'framer-motion'
import { FaPhone, FaEnvelope, FaCheck, FaExclamationTriangle } from 'react-icons/fa'
import './Pricing.css'

const Pricing = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  }

  return (
    <section className="pricing-section section">
      <div className="container">
        <motion.div
          className="pricing-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h1 className="section-title">Ceník</h1>
        </motion.div>

        <motion.div
          className="pricing-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Letní sezóna */}
          <motion.div className="season-card" variants={itemVariants}>
            <div className="season-header">
              <h3 className="season-title">
                <span className="season-label">Sezóna</span> Léto - červen, červenec, srpen, září
              </h3>
              <p className="season-description">
                V létě jsou preferovány týdenní pobyty od neděle do neděle. Pokud máte jiný požadavek, prosím kontaktujte majitele
              </p>
              <div className="contact-links">
                <a href="tel:775112341" className="contact-link">
                  <FaPhone />
                  tel: (+420)775 112 341
                </a>
                <a href="mailto:info@penzionjilovanka.cz" className="contact-link">
                  <FaEnvelope />
                  info@penzionjilovanka.cz
                </a>
              </div>
            </div>
            <div className="pricing-list">
              <div className="price-item">
                <span className="duration">týden</span>
                <span className="price">65 500,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">6 nocí</span>
                <span className="price">57 750,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">5 nocí</span>
                <span className="price">49 500,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">4 noci</span>
                <span className="price">40 500,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">3 noci</span>
                <span className="price">31 000,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">2 noci</span>
                <span className="price">21 000,-Kč</span>
              </div>
            </div>
          </motion.div>

          {/* Zimní sezóna */}
          <motion.div className="season-card" variants={itemVariants}>
            <div className="season-header">
              <h3 className="season-title">
                <span className="season-label">Sezóna</span> Zima - leden, únor, březen, listopad, prosinec (topné období)
              </h3>
              <p className="season-description">
                V zimě jsou preferovány týdenní pobyty od neděle do neděle. Pokud máte jiný požadavek, prosím kontaktujte majitele
              </p>
              <div className="contact-links">
                <a href="tel:775112341" className="contact-link">
                  <FaPhone />
                  tel: (+420)775 112 341
                </a>
                <a href="mailto:info@penzionjilovanka.cz" className="contact-link">
                  <FaEnvelope />
                  info@penzionjilovanka.cz
                </a>
              </div>
            </div>
            <div className="pricing-list">
              <div className="price-item">
                <span className="duration">týden</span>
                <span className="price">70 500,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">6 nocí</span>
                <span className="price">62 500,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">5 nocí</span>
                <span className="price">53 500,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">4 noci</span>
                <span className="price">44 000,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">3 noci</span>
                <span className="price">33 000,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">2 noci</span>
                <span className="price">22 500,-Kč</span>
              </div>
            </div>
          </motion.div>

          {/* Mimo sezóna */}
          <motion.div className="season-card" variants={itemVariants}>
            <div className="season-header">
              <h3 className="season-title">
                <span className="season-label">Mimo sezóna</span> - duben, květen, říjen (topné období)
              </h3>
              <div className="contact-links">
                <a href="tel:775112341" className="contact-link">
                  <FaPhone />
                  tel: (+420)775 112 341
                </a>
                <a href="mailto:info@penzionjilovanka.cz" className="contact-link">
                  <FaEnvelope />
                  info@penzionjilovanka.cz
                </a>
              </div>
            </div>
            <div className="pricing-list">
              <div className="price-item">
                <span className="duration">týden</span>
                <span className="price">68 500,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">6 nocí</span>
                <span className="price">60 500,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">5 nocí</span>
                <span className="price">52 000,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">4 noci</span>
                <span className="price">42 500,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">3 noci</span>
                <span className="price">32 000,-Kč</span>
              </div>
              <div className="price-item">
                <span className="duration">2 noci</span>
                <span className="price">22 000,-Kč</span>
              </div>
            </div>
          </motion.div>

          {/* Ostatní informace (přesný text) */}
<motion.div className="info-card" variants={itemVariants}>
  <h3 className="info-title">
    <span className="info-label">Ostatní</span> informace
  </h3>

  <ul className="info-list">
    <li className="info-item">
      <FaCheck className="info-icon" />
      <span>Nejsou účtovány žádné další poplatky za energie.</span>
    </li>

    <li className="info-item">
      <FaCheck className="info-icon" />
      <span>V den příjezdu je vybírána kauce v hotovosti 5 000 Kč, vratná v den odjezdu po předání nemovitosti.</span>
    </li>

    <li className="info-item">
      <FaExclamationTriangle className="info-icon warning" />
      <span>Oslavné víkendové akce – svatby, narozeniny, rozlučky se svobodou a jiné oslavy – příplatek 5 000 Kč.</span>
    </li>

    <li className="info-item">
      <FaCheck className="info-icon" />
      <span>
        V případě jiných požadavků nás neváhejte kontaktovat, pokusíme se Vám vyjít vstříc:&nbsp;
        <a href="tel:+420775112341" className="contact-link">tel: (+420) 775 112 341</a>
      </span>
    </li>

    <li className="info-item">
      <FaCheck className="info-icon" />
      <span>Vlastník bydlí v nemovitosti v oddělené sekci domu.</span>
    </li>

    <li className="info-item">
      <FaExclamationTriangle className="info-icon warning" />
      <span>Zákaz vstupu domácím mazlíčkům.</span>
    </li>

    <li className="info-item">
      <FaCheck className="info-icon" />
      <span>Poplatky obce dle vyhlášky. Pouze osoby 18+, 30 Kč / osoba / noc – platí od 1. 1. 2026.</span>
    </li>

    <li className="info-item">
      <FaCheck className="info-icon" />
      <span>Nekuřácký prostor.</span>
    </li>
    <li className="info-item">
      <FaCheck className="info-icon" />
      <span>Závěrečný úklid si dělá každá skupina sama (bez koupelen)</span>
    </li>
  </ul>
</motion.div>

        </motion.div>
      </div>
    </section>
  )
}

export default Pricing
